import type { ReactNode } from 'react';
import { cx } from '../../lib/util/cx';

/** Port of the DS `FormField`: 13px/600 ink label, 12px hint, 13px danger error. */
export interface FormFieldProps {
  label?: ReactNode;
  htmlFor?: string;
  required?: boolean;
  optional?: boolean;
  error?: ReactNode;
  hint?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function FormField({ label, htmlFor, required, optional, error, hint, className, children }: FormFieldProps) {
  const messageId = htmlFor ? `${htmlFor}-message` : undefined;
  return (
    <div className={cx('flex flex-col gap-1.5 font-body', className)}>
      {label && (
        <label htmlFor={htmlFor} className="text-[13px] font-semibold text-ink">
          {label}
          {required && <span className="text-danger"> *</span>}
          {optional && <span className="font-normal text-muted"> (optional)</span>}
        </label>
      )}
      {children}
      {hint && !error && (
        <p id={messageId} className="m-0 text-xs text-muted">
          {hint}
        </p>
      )}
      {error && (
        <p id={messageId} role="alert" className="m-0 text-[13px] text-danger">
          {error}
        </p>
      )}
    </div>
  );
}
